import React, { useEffect, useRef, useState } from "react";
import DwgNavigator from "./DwgNavigator";

export default function DwgAutodeskViewer()
{
    const autodeskContainerRef =
            useRef(null);

    const autodeskViewerRef =
            useRef(null);


    const [viewerData, setViewerData] =
            useState(null);

    const [selectedEntity, setSelectedEntity] =
            useState(null);


    //
    // Load URN + entities from our servlet
    //

    useEffect(() =>
    {
        let cancelled =
                false;


        async function loadViewerData()
        {
            try
            {
                const response =
                        await fetch(
                            "/resolutionsoftwareplatform/gettestdwgviewer",
                            {
                                method: "GET",
                                cache: "no-store"
                            });


                if(!response.ok)
                {
                    console.error(
                        "Unable to get Autodesk viewer data");

                    return;
                }


                const data =
                        await response.json();


                if(cancelled)
                {
                    return;
                }


                console.log(
                    "Autodesk viewer data:",
                    data);


                setViewerData(
                        data);
            }
            catch(error)
            {
                console.error(
                    "Error loading Autodesk viewer data:",
                    error);
            }
        }


        loadViewerData();


        return () =>
        {
            cancelled =
                    true;
        };

    }, []);


    //
    // Initialise Autodesk Viewer when the
    // backend data has arrived.
    //

    useEffect(() =>
    {
        if(viewerData == null ||
           viewerData.urn == null)
        {
            return;
        }


        if(autodeskContainerRef.current == null)
        {
            return;
        }


        if(window.Autodesk == null)
        {
            console.error(
                "Autodesk Viewer library is not loaded");

            return;
        }


        let cancelled =
                false;


        const options =
        {
            env: "AutodeskProduction2",
            api: "streamingV2_EU",

            getAccessToken:
                async function(onTokenReady)
                {
                    try
                    {
                        const response =
                                await fetch(
                                    "/resolutionsoftwareplatform/getforgeviewertoken",
                                    {
                                        method: "GET",
                                        cache: "no-store"
                                    });


                        const data =
                                await response.json();


                        if(data == null ||
                           data.accessToken == null)
                        {
                            console.error(
                                "No Autodesk access token returned");

                            return;
                        }


                        onTokenReady(
                            data.accessToken,
                            data.expiresIn || 3500);
                    }
                    catch(error)
                    {
                        console.error(
                            "Unable to obtain Autodesk viewer token:",
                            error);
                    }
                }
        };


        window.Autodesk.Viewing.Initializer(
            options,
            function()
            {
                if(cancelled)
                {
                    return;
                }


                const viewer =
                        new window.Autodesk.Viewing.GuiViewer3D(
                            autodeskContainerRef.current);


                autodeskViewerRef.current =
                        viewer;


                const started =
                        viewer.start();


                console.log(
                    "Autodesk viewer started:",
                    started);


                const documentId =
                        viewerData.urn.startsWith("urn:")
                            ? viewerData.urn
                            : "urn:" +
                              viewerData.urn;


                console.log(
                    "Loading Autodesk document:",
                    documentId);


                window.Autodesk.Viewing.Document.load(
                    documentId,

                    function(document)
                    {
                        if(cancelled)
                        {
                            return;
                        }


                        console.log(
                            "Autodesk document loaded");


                        const geometry =
                                document
                                    .getRoot()
                                    .getDefaultGeometry();


                        if(geometry == null)
                        {
                            console.error(
                                "No default geometry found");

                            return;
                        }


                        viewer.loadDocumentNode(
                            document,
                            geometry)
                            .then(function(model)
                            {
                                console.log(
                                    "Autodesk model loaded:",
                                    model);
                            })
                            .catch(function(error)
                            {
                                console.error(
                                    "Unable to load Autodesk model:",
                                    error);
                            });
                    },

                    function(errorCode, errorMessage)
                    {
                        console.error(
                            "Autodesk document load failed:",
                            errorCode,
                            errorMessage);
                    });
            });


        return () =>
        {
            cancelled =
                    true;


            if(autodeskViewerRef.current != null)
            {
                try
                {
                    autodeskViewerRef.current.finish();
                }
                catch(error)
                {
                }


                autodeskViewerRef.current =
                        null;
            }
        };

    }, [viewerData]);


    //
    // Select desk in Autodesk viewer
    //

	function selectAutodeskEntity(entity)
	{
	    const viewer =
	            autodeskViewerRef.current;


	    if(viewer == null ||
	       entity == null)
	    {
	        return;
	    }


	    //
	    // Clicking the currently selected entity
	    // again deselects it and returns to the
	    // complete drawing.
	    //

	    if(selectedEntity != null &&
	       selectedEntity.autodeskId === entity.autodeskId)
	    {
	        viewer.clearSelection();


	        setSelectedEntity(
	            null);


	        //
	        // Fit the complete model back into view.
	        //

	        viewer.fitToView();


	        return;
	    }


	    //
	    // New entity selected.
	    //

	    setSelectedEntity(
	        entity);


	    viewer.clearSelection();


	    viewer.select(
	        [entity.autodeskId]);


	    viewer.fitToView(
	        [entity.autodeskId]);
	}


    //
    // Styles
    //

  

    //
    // Render
    //

    return (
        <div
            style={{
                position: "relative",
                width: "100%",
                height: "100%"
            }}
        >

            {/* AUTODESK VIEWER */}

            <div
                ref={autodeskContainerRef}
                style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    overflow: "hidden"
                }}
            />


			{/* DRAWING NAVIGATOR */}

			<DwgNavigator
			    entities={
			        viewerData &&
			        viewerData.entities
			            ? viewerData.entities
			            : []
			    }

			    selectedEntity={
			        selectedEntity
			    }

			    onSelect={
			        selectAutodeskEntity
			    }

			    category="DESKS"
			/>

        </div>
    );
}